import type {
  ConditionOperator,
  FilterCondition,
  QueryFiltersUrlParams,
} from "schemas/generated/analyticsRead";

import { ReploError } from "schemas/errors";

class FailedUpdatingUrlParamsFilters extends ReploError {}

export function findLabelForValue(
  options: { displayValue: string; value: string }[],
  value: string,
): string | undefined {
  const selectedOption = options.find((option) => option.value === value);
  return selectedOption?.displayValue ?? undefined;
}

export function addEntryToUrlParams({
  currentUrlParams,
  urlParamToAdd,
}: {
  currentUrlParams: QueryFiltersUrlParams;
  urlParamToAdd: {
    attribute: string;
    operator: ConditionOperator;
    value: string;
  };
}): QueryFiltersUrlParams {
  const { attribute, operator, value } = urlParamToAdd;

  const newUrlParamEntry = {
    operator,
    value: ["equals", "does_not_equal"].includes(operator) ? [value] : value,
  } as FilterCondition;

  const updatedUrlParams: QueryFiltersUrlParams = {
    ...currentUrlParams,
    [attribute]: [...(currentUrlParams[attribute] ?? []), newUrlParamEntry],
  };

  return updatedUrlParams;
}

export function removeEntryFromUrlParams({
  currentUrlParams,
  urlParamToRemove,
}: {
  currentUrlParams: QueryFiltersUrlParams;
  urlParamToRemove: {
    attribute: string;
    operator: ConditionOperator;
    value: string | string[];
  };
}): QueryFiltersUrlParams {
  const { attribute, operator, value } = urlParamToRemove;

  const attributeFilterConditions = currentUrlParams[attribute];

  if (!attributeFilterConditions) {
    throw new FailedUpdatingUrlParamsFilters({
      message:
        "The attribute attempted to be removed doesn't exist in the filter's urlParams",
      additionalData: {
        currentUrlParams,
        urlParamToRemove,
      },
    });
  }

  const updatedFilterConditions: FilterCondition[] =
    attributeFilterConditions.filter((filterCondition: FilterCondition) => {
      return !(
        filterCondition.operator === operator &&
        JSON.stringify(filterCondition.value) === JSON.stringify(value)
      );
    });

  return {
    ...currentUrlParams,
    [attribute]: updatedFilterConditions,
  };
}
